// extracted by mini-css-extract-plugin
module.exports = {"root":"my-bookings-loader_root__2OZPU"};